import React, { useEffect, useRef, useState } from "react";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, useMap, Polyline } from "react-leaflet";
import styles from "./MapWrapper.module.scss";
import { getMapFitCoords, getRidePhase, isValidCoord, shouldShowDriverOnMap } from "../rideStatus";

const pinFrom = new L.Icon({
  iconUrl: "/pin_from.png",
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  popupAnchor: [48, 24],
});
const pinWaypoint = new L.Icon({
  iconUrl: "/ic_24_stop_pin2.svg",
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  popupAnchor: [48, 24],
});

const pinTo = new L.Icon({
  iconUrl: "/destination_pin2.svg",
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  popupAnchor: [48, 0],
});

const pinDriver = new L.icon({
  iconUrl: "/pin_car.svg",
  iconSize: [48, 48],
  iconAnchor: [24, 48],
  popupAnchor: [48, 24],
  className: styles.driverMarker,
});

const MapWrapper = ({ rideDetails }) => {
  const [mapServiceData, setMapServiceData] = useState();

  useEffect(() => {
    const mapData = rideDetails?.route_info;
    if (mapData?.route) {
      setMapServiceData({
        ...mapData,
        shape: remappedCoordinates(mapData.route),
      });
    } else {
      setMapServiceData(undefined);
    }
  }, [rideDetails]);

  const markerRef = useRef();

  return (
    <div>
      <MapContainer
        maxZoom={16}
        minZoom={10}
        className={styles.mapWrap}
        center={[44.83747771561463, 20.410867113723057]}
        zoom={13}
        bounds={[
          [44.975563009492674, 20.171056176197784],
          [44.65554467734727, 20.746465087431673],
        ]}
        scrollWheelZoom={false}>
        <MapHandler rideDetails={rideDetails} />
        <TileLayer
          attribution="CAR:GO"
          url="https://basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png?key=cb1_2g08_1_e9d474a7cdba96691b28ac2c"
        />
        {mapServiceData && <Polyline positions={mapServiceData?.shape} color="#3BD4AE" opacity={0.8} weight={2} />}{" "}
        {rideDetails?.waypoints?.map((waypoint, index) => (
          <Marker key={index} ref={markerRef} icon={pinWaypoint} position={[waypoint.lat, waypoint.lng]} />
        ))}
        {shouldShowDriverOnMap(rideDetails) && (
          <Marker
            ref={markerRef}
            icon={pinDriver}
            position={[rideDetails.current_latitude, rideDetails.current_longitude]}
          />
        )}
        {isValidCoord(rideDetails?.destination_latitude, rideDetails?.destination_longitude) && (
          <Marker
            draggable={false}
            icon={pinTo}
            position={[rideDetails.destination_latitude, rideDetails.destination_longitude]}
          />
        )}
        {isValidCoord(rideDetails?.location_latitude, rideDetails?.location_longitude) && (
          <Marker icon={pinFrom} position={[rideDetails.location_latitude, rideDetails.location_longitude]} />
        )}
      </MapContainer>
    </div>
  );
};

export default MapWrapper;

export const MapHandler = ({ rideDetails }) => {
  const map = useMap();

  map.attributionControl.setPrefix("");

  const prevRideDetails = useRef();

  useEffect(() => {
    const phase = getRidePhase(rideDetails);
    const fitArray = getMapFitCoords(rideDetails).map(([lat, lng]) => L.latLng(lat, lng));

    if (rideDetails && prevRideDetails.current?.phase !== phase) {
      reCenterFunc(map, fitArray);
    }

    prevRideDetails.current = { ...rideDetails, phase };
  }, [rideDetails]);
};

const remappedCoordinates = (coordinates) =>
  coordinates.map((coord) => {
    const [lat, lng] = coord.split(",").map(parseFloat);
    return [lat, lng];
  });

const reCenterFunc = (map, fitArray = []) => {
  if (fitArray.length > 0) {
    map.fitBounds(fitArray, {
      padding: [50, 50],
    });
  }
};
